import theme from '@/constants/theme';

export const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flex: 1,
    backgroundColor: 'inherit',
    padding: 16,
    paddingTop: 8,
    flexDirection: 'column',
    // paddingBottom: Platform.OS === "android" ? 100 : 16,
    maxHeight: 'auto',
    overflow: 'auto',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    backgroundColor: 'inherit',
    // marginBottom: 16,
    maxHeight: 'auto',
    overflow: 'hidden',
  },
  title: {
    color: theme.colors.text.title,
  },
  text: {
    color: theme.colors.text.body,
  },
  indicatorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'inherit',
  },
  typeIndicator: {
    color: theme.colors.text.caption,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: 'inherit',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    backgroundColor: 'inherit',
  },
  actionButton: {
    borderRadius: 32,
    width: 40,
    height: 40,
    borderStyle: 'solid',
    borderWidth: 1,
    padding: 8,
    backgroundColor: 'inherit',
    borderColor: theme.colors.primary,
    color: theme.colors.primary,
  },
  contentSlot: {
    flex: 1,
    display: 'flex',
    backgroundColor: 'inherit',
    overflow: 'auto',
    maxHeight: '100%',
  },
  pointsContainer: {
    color: theme.colors.primary,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: 'inherit',
  },
  pointsIndicator: {
    color: theme.colors.primary,
    fontWeight: 'bold',
  },
};
